import { Config } from "plotly.js";
import ltLocale from "plotly.js/lib/locales/lt";
import plLocale from "plotly.js/lib/locales/pl";
import { useUserState } from "store/user-store";

const useDefaultPlotlyConfig = () => {
  const language = useUserState(state => state.getLanguage());

  const defaultPlotlyConfig: Partial<Config> = {
    displaylogo: false,
    locales: { lt: ltLocale, pl: plLocale },
    locale: language,
    modeBarButtonsToRemove: ["lasso2d", "select2d"],
  };

  return defaultPlotlyConfig;
};

export default useDefaultPlotlyConfig;
